import IconCopy from "app/components/Icon/components/IconCopy/IconCopy";
import LoadingSpinner from "app/components/LoadingSpinner/LoadingSpinner";
import { WithdrawDetailsType } from "app/types/cryptoType";
import { UserType } from "app/types/userType";
import { ChangeEventHandler, Component, MouseEventHandler } from "react";
import Countdown, { CountdownTimeDelta } from "react-countdown";
import { CountdownTimeDeltaFn } from "react-countdown/dist/Countdown";
import { FormattedMessage } from "react-intl";
import CryptoFundingWithdrawFailed from "./components/CryptoFundingWithdrawFailed/CryptoFundingWithdrawFailed";
import CryptoFundingWithdrawNew from "./components/CryptoFundingWithdrawNew/CryptoFundingWithdrawNew";
import CryptoFundingWithdrawPending from "./components/CryptoFundingWithdrawPending/CryptoFundingWithdrawPending";
import CryptoFundingWithdrawSuccess from "./components/CryptoFundingWithdrawSuccess/CryptoFundingWithdrawSuccess";
import "./CryptoFundingCompleteWithdraw.scss";

type Props = {
  withdrawDetails: WithdrawDetailsType;
  requestQuote: CountdownTimeDeltaFn;
  requestWithdraw: MouseEventHandler;
  cancelWithdraw: MouseEventHandler;
  onChangeAddress: ChangeEventHandler;
  user: UserType;
  currency: string;
  withdrawError: string;
  backToHomepage: MouseEventHandler;
  quoteLoading: boolean;
  copyAmountInfo: MouseEventHandler;
  isProcessing: boolean;
  status: string;
};

class CryptoFundingCompleteWithdraw extends Component<Props> {
  timeRenderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      return <span>EXPIRED</span>;
    } else {
      return (
        <span>
          {minutes < 10 && 0}
          {minutes}:{seconds < 10 && 0}
          {seconds}
        </span>
      );
    }
  };
  onCountdownMount = (timeDelta: CountdownTimeDelta) => {
    if (timeDelta.total === 0) {
      this.props.requestQuote();
    }
  };
  render() {
    const {
      withdrawDetails,
      requestQuote,
      requestWithdraw,
      cancelWithdraw,
      onChangeAddress,
      user,
      currency,
      withdrawError,
      backToHomepage,
      quoteLoading,
      copyAmountInfo,
      isProcessing,
      status,
    } = this.props;
    console.log(
      "CryptoFundingCompleteWithdraw withdrawDetails: ",
      withdrawDetails
    );
    console.log("CryptoFundingCompleteWithdraw status: ", status);
    console.log("CryptoFundingCompleteWithdraw isProcessing: ", isProcessing);
    const showExpiry =
      !quoteLoading &&
      withdrawDetails.status === null &&
      withdrawDetails.expireTime;
    return (
      <div className="crypto-funding-withdraw-complete-withdraw">
        {/* QUOTE INFO --- DON'T SHOW THIS ONCE THE WITHDRAW REQUEST HAS BEEN SENT */}
        {!isProcessing && (
          <div className="crypto-funding-withdraw-complete-withdraw__quote-info">
            <div className="crypto-funding-withdraw-complete-withdraw__title">
              <FormattedMessage id="cashier-crypto-quote" />
            </div>
            {!quoteLoading && (
              <div className="crypto-funding-withdraw-complete-withdraw__amount">
                <span>{`${withdrawDetails.amountSending} ${
                  user["currencyCode"]
                } = ${withdrawDetails.receiveQuantity} ${currency.replace(
                  /_/g,
                  "-"
                )}`}</span>
                <IconCopy onClick={copyAmountInfo} />
              </div>
            )}
            {showExpiry && (
              <div className="crypto-funding-withdraw-complete-withdraw__quote-info__expiry-message">
                <FormattedMessage id="cashier-expiry-message-start" />
                <Countdown
                  date={withdrawDetails.expireTime}
                  renderer={this.timeRenderer}
                  zeroPadTime={2}
                  onComplete={requestQuote}
                  onMount={this.onCountdownMount}
                />
                <FormattedMessage id="cashier-expiry-message-end" />
              </div>
            )}
            {!quoteLoading && (
              <FormattedMessage
                tagName={"div"}
                id="cashier-crypto-exchange-fees"
              />
            )}
            {quoteLoading && <LoadingSpinner />}
          </div>
        )}
        {!isProcessing && (
          <CryptoFundingWithdrawNew
            user={user}
            withdrawDetails={withdrawDetails}
            currency={currency}
            onChangeAddress={onChangeAddress}
            requestWithdraw={requestWithdraw}
            cancelWithdraw={cancelWithdraw}
            withdrawError={withdrawError}
          />
        )}
        {/*  */}
        {(status === "NEW" || status === "PENDING_APPROVAL") && (
          <CryptoFundingWithdrawPending
            currency={currency}
            withdrawDetails={withdrawDetails}
            user={user}
            backToHomepage={backToHomepage}
            cancelWithdraw={cancelWithdraw}
          />
        )}
        {status === "SUCCESS" && (
          <CryptoFundingWithdrawSuccess
            currency={currency}
            withdrawDetails={withdrawDetails}
            user={user}
            backToHomepage={backToHomepage}
            cancelWithdraw={cancelWithdraw}
          />
        )}
        {(status === "REJECT" || status === "ERROR") && (
          <CryptoFundingWithdrawFailed
            currency={currency}
            withdrawDetails={withdrawDetails}
            user={user}
            cancelWithdraw={cancelWithdraw}
          />
        )}
      </div>
    );
  }
}

export default CryptoFundingCompleteWithdraw;
